export enum AlwaysRefreshRoutesEnum {
  FreightExchange = '/secure/freight-exchange',
  Incidents = '/secure/incidents',
}
